import { render, staticRenderFns } from "./IntentProjects.vue?vue&type=template&id=86309c60&scoped=true"
import script from "./IntentProjects.vue?vue&type=script&lang=js"
export * from "./IntentProjects.vue?vue&type=script&lang=js"
import style0 from "./IntentProjects.vue?vue&type=style&index=0&id=86309c60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86309c60",
  null
  
)

export default component.exports